import { useGetHeaders } from "@hooks/useGetHeaders";
import { TryAndBuy as TryAndBuyMC } from "@lib/constants/contentful/try-and-buy";
import { useState } from "react";

export const useTryAndBuyModal = () => {
    const [isOpen, setIsOpen] = useState(false);

    const { label } = useGetHeaders({
        microcopiesWithTitles: {
            label: TryAndBuyMC.label,
        },
    });

    const onOpen = () => setIsOpen(true);
    const onClose = () => setIsOpen(false);

    return {
        onOpen,
        isOpen,
        onClose,
        label,
    };
};
